import { useSelector } from 'react-redux';
import { ACTION_SETTINGS } from 'reactApp/appHelpers/actionSettings';
import { welcomeTrialParamsNew, welcomeTrialParamsOverquota } from 'reactApp/appHelpers/featuresHelpers';
import { hideOverquotaFeatures } from 'reactApp/appHelpers/featuresHelpers/features/overquotaCommunications';
import { isDefaultRootContent } from 'reactApp/modules/home/home.selectors';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
export const useShow1tbPromo = () => {
    const isDefaultContent = useSelector(isDefaultRootContent);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isB2BUser = useSelector(UserSelectors.isB2BUser);
    const { isLoaded: isQuotaLoaded } = useSelector(UserQuotaSelectors.getLoadingState);
    const isUserWithoutPayment = useSelector(PaidInfoSelectors.isUserWithoutPayment);

    const isOverquota = useSelector(isCloudOrMailOrApiOverQuota);
    const trial = isOverquota ? welcomeTrialParamsOverquota : welcomeTrialParamsNew;
    const isTrialAvailable = useSelector((state) => ProductsSelectors.isTrialAvailable(state, trial.productId));

    const showWelcomePromo = isDefaultContent && !isPaidUser && !isB2BUser && isUserWithoutPayment && isTrialAvailable;

    if (isOverquota && hideOverquotaFeatures.trial1tbBannerPromo) {
        return false;
    }

    return isQuotaLoaded && !ACTION_SETTINGS.hide1TbTrialPromo && !showWelcomePromo;
};
